<!-- All attachments located under `Guardians` under the 'Cash Catch folder > Cash Catch Challenge'  on CMS-->
<template>
    <div class="background8Bit">
        <div id="test-panel" v-if="testing">
            <button class="button" @click="ToggleTest()">Toggle</button>
            <!--no game today-->
            <button v-if="testingToggle" class="button" @click="getState(0)">No Game</button>
            <!--game is not active BUT baseball game is going on (pre-game state)-->
            <button v-if="testingToggle" class="button" @click="getState(1)">PreGame</button>
            <!--game is active Landing page-->
            <button v-if="testingToggle" class="button" @click="getState(2)">Landing</button>
            <!--gameplay Camera-->
            <button v-if="testingToggle" class="button" @click="getState(3)">Camera</button>
            <!--gameplay Parallax Guardians-->
            <button v-if="testingToggle" class="button" @click="getState(4)">Guards</button>
            <!--gameplay Parallax Reds-->            
            <button v-if="testingToggle" class="button" @click="getState(5)">Reds</button>
            <!--Loose page not Logged In-->
            <button v-if="testingToggle" class="button" @click="getState(6)">Loose</button>
            <!--Loose page is Logged In-->            
            <button v-if="testingToggle" class="button" @click="getState(7)">L Log</button>
            <!--Win page not Logged In-->
            <button v-if="testingToggle" class="button" @click="getState(8)">Win</button>
            <!--Win page is Logged In-->
            <button v-if="testingToggle" class="button" @click="getState(9)">W Log</button>
            <!--user has already played the game-->
            <button v-if="testingToggle" class="button" @click="getState(10)">Already</button>
        </div>

        <!-- Navigation -->
        <MobileMenu/>

        <!-- Panel 10: Player has already played the game today -->
        <transition name="slideStagger" @before-enter="beforeEnterStagger" @enter="enterStagger">
            <div v-if="currentState === 10" class="notTimeYet DivWrapper8Bit">
                <div class="notyetAnimation" ref="staggerParent">
                    <img class="LandingHead8bit" alt="Cash Catch Pop-Fly Challenge" src="/getattachment/4fd95a03-75a2-4fac-8c38-6728ec741093/CashCatch-LandingHeader.png"/>
                    <p class="Head8bit">Thank you for playing</p>
                    <p class="SubHead8bit">Click HOW TO PLAY in the menu to see when you can try again.</p>
                </div>
                <div class="LandingFooter8bitWrapper">
                    <div class="LandingFooter8bit lightenBackground"></div>

                    <img class="LandingFooter8bit Multiply" src="/getattachment/1a66e3b9-73a1-43e2-8061-440ba8c8f588/CashCatch-LandingFooter-Mulitply.png"/>
                    <img class="LandingFooter8bit Darken" src="/getattachment/2ff4026a-db45-4c73-8da8-5288a90fa169/CashCatch-LandingFooter-Darken.png"/>
                </div>
            </div>
        </transition>

        <!-- Panel 0: game not active too far in advance -->
        <transition name="slideStagger" @before-enter="beforeEnterStagger" @enter="enterStagger">
            <div v-if="currentState === 0" class="notTimeYet DivWrapper8Bit">
                <div class="notyetAnimation" ref="staggerParent">
                    <img class="LandingHead8bit" alt="Cash Catch Pop-Fly Challenge" src="/getattachment/4fd95a03-75a2-4fac-8c38-6728ec741093/CashCatch-LandingHeader.png"/>
                    <p class="Head8bit">There is no game today.</p>
                    <p class="SubHead8bit">Click HOW TO PLAY in the menu to see when you can try again.</p>
                </div>
                <div class="LandingFooter8bitWrapper">
                    <div class="LandingFooter8bit lightenBackground"></div>

                    <img class="LandingFooter8bit Multiply" src="/getattachment/1a66e3b9-73a1-43e2-8061-440ba8c8f588/CashCatch-LandingFooter-Mulitply.png"/>
                    <img class="LandingFooter8bit Darken" src="/getattachment/2ff4026a-db45-4c73-8da8-5288a90fa169/CashCatch-LandingFooter-Darken.png"/>
                </div>
            </div>
        </transition>

        <!-- Panel 1: Pregame State -->
        <transition name="slideStagger" @before-enter="beforeEnterStagger" @enter="enterStagger">
            <div v-if="currentState === 1" class="notTimeYet DivWrapper8Bit">
                <div class="notyetAnimation" ref="staggerParent">
                    <img class="LandingHead8bit" alt="Cash Catch Pop-Fly Challenge" src="/getattachment/4fd95a03-75a2-4fac-8c38-6728ec741093/CashCatch-LandingHeader.png"/>
                    <p class="Head8bit">Oops, it's not game time.</p>
                    <p class="SubHead8bit"> {{ apiTeam === 0 ? `Keep an eye on the scoreboard starting after the bottom of the fourth inning and scan the QR code.` : 'Come back between the fourth and fifth inning and scan the QR code.' }} </p>
                </div>
                <div class="LandingFooter8bitWrapper">
                    <div class="LandingFooter8bit lightenBackground"></div>

                    <img class="LandingFooter8bit Multiply" src="/getattachment/1a66e3b9-73a1-43e2-8061-440ba8c8f588/CashCatch-LandingFooter-Mulitply.png"/>
                    <img class="LandingFooter8bit Darken" src="/getattachment/2ff4026a-db45-4c73-8da8-5288a90fa169/CashCatch-LandingFooter-Darken.png"/>
                </div>
            </div>
        </transition>

        <!-- Panel 2: game Active Landing page -->
        <transition name="slideStagger" @before-enter="beforeEnterStagger" @enter="enterStagger" @leave="leaveStagger">
            <div v-if="currentState === 2" class="Landing8bit DivWrapper8Bit">
                <div class="LandingPosition" ref="staggerParent">
                    <img class="LandingHead8bit" alt="Cash Catch Pop-Fly Challenge" src="/getattachment/4fd95a03-75a2-4fac-8c38-6728ec741093/CashCatch-LandingHeader.png"/>
                    <p class="Body8bit yellow">Your phone is your glove!</p>
                    <p class="Body8bit" >Catch digital fly balls for a chance to win <strong>$50 in Digital Lottery Cash</strong> or an entry into a <strong>Grand Prize Drawing.</strong></p>
                    <p class="Disclaimer8bit">For the best game experience, please allow access to your phone’s camera.</p>
                    <p class="pMargin8Bit checkbox8bit">
                        <input type="checkbox" id="acceptTerms" v-model="isChecked" />
                        <label class="Disclaimer8bit checkboxtext" for="acceptTerms"> I verify that I am 18 years of age or older.</label>
                    </p>

                    <div v-if="showError" class="Popup">
                        <button class="close-btn" @click="showError = false">✖</button>
                        <p class="PopupHead8bit">Sorry, you must be at least 18 years old to play the Cash Catch Challenge. </p>
                        <button @click="showError = false" class="Button8bit">Close</button>
                    </div>

                    <button class="Button8bit" @click="requestMotionPermission()">PLAY NOW</button>
                </div>

                <div class="LandingFooter8bitWrapper">
                    <div class="LandingFooter8bit lightenBackground"></div>

                    <img class="LandingFooter8bit Multiply" src="/getattachment/1a66e3b9-73a1-43e2-8061-440ba8c8f588/CashCatch-LandingFooter-Mulitply.png"/>
                    <img class="LandingFooter8bit Darken" src="/getattachment/2ff4026a-db45-4c73-8da8-5288a90fa169/CashCatch-LandingFooter-Darken.png"/>
                </div>
            </div>
        </transition>

        <div v-if="gameplay === true && [3, 4, 5].includes(currentState)" >
            <div class="circle-ring ring-enter"></div>
        </div>
        <!-- Panel 3,4,5: Gameplay -->
        <transition name="circle"> 
            <div class="cashCatch_game" v-if="gameplay === true && [3, 4, 5].includes(currentState)" >
                <div id="gameArea" class="gameArea"></div>
                <img src="/getattachment/264a9eac-628f-4bec-9eeb-5137d101612b/CashCatch-GameMitt.png" class="Glove8bitGame" />
                <div class="ar-instructions">Eye on the ball! <br/> {{ camera ? 'Move your phone to catch it.' : 'Swipe your phone to catch it.' }}</div>

                <img :src="this.flybyURL[0]" alt="" class="cashCatch_overlay_image_flyby" v-if="this.chosenFlyby === 'flyby1'">
                <img :src="this.flybyURL[0]" alt="" class="cashCatch_overlay_image_flyby" v-if="this.chosenFlyby === 'flyby1alt'" style="transform: translateX(-50%) scaleX(-1)">
                <img :src="this.flybyURL[1]" alt="" class="cashCatch_overlay_image_flyby" v-if="this.chosenFlyby === 'flyby2'">
                <img :src="this.flybyURL[1]" alt="" class="cashCatch_overlay_image_flyby" v-if="this.chosenFlyby === 'flyby2alt'" style="transform: translateX(-50%) scaleX(-1)">
                <img :src="this.flybyURL[2]" alt="" class="cashCatch_overlay_image_flyby" v-if="this.chosenFlyby === 'flyby3'">
                <img :src="this.flybyURL[2]" alt="" class="cashCatch_overlay_image_flyby" v-if="this.chosenFlyby === 'flyby3alt'" style="transform: translateX(-50%) scaleX(-1)">
                
                <img :src="this.endURLred[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1' && this.LayerColorIndex === 0">
                <img :src="this.endURLred[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1alt' && this.LayerColorIndex === 0" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLred[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2' && this.LayerColorIndex === 0">
                <img :src="this.endURLred[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2alt' && this.LayerColorIndex === 0" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLred[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3' && this.LayerColorIndex === 0"   style="z-index: 5;">
                <img :src="this.endURLred[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3alt' && this.LayerColorIndex === 0" style="transform: translateX(-50%) scaleX(-1); z-index: 5;">

                <img :src="this.endURLgreen[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1' && this.LayerColorIndex === 1">
                <img :src="this.endURLgreen[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1alt' && this.LayerColorIndex === 1" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLgreen[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2' && this.LayerColorIndex === 1">
                <img :src="this.endURLgreen[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2alt' && this.LayerColorIndex === 1" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLgreen[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3' && this.LayerColorIndex === 1"   style="z-index: 5;">
                <img :src="this.endURLgreen[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3alt' && this.LayerColorIndex === 1" style="transform: translateX(-50%) scaleX(-1); z-index: 5;">

                <img :src="this.endURLblue[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1' && this.LayerColorIndex === 2">
                <img :src="this.endURLblue[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1alt' && this.LayerColorIndex === 2" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLblue[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2' && this.LayerColorIndex === 2">
                <img :src="this.endURLblue[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2alt' && this.LayerColorIndex === 2" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLblue[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3' && this.LayerColorIndex === 2"   style="z-index: 5;">
                <img :src="this.endURLblue[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3alt' && this.LayerColorIndex === 2" style="transform: translateX(-50%) scaleX(-1); z-index: 5;">

                <img :src="this.endURLorange[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1' && this.LayerColorIndex === 3">
                <img :src="this.endURLorange[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1alt' && this.LayerColorIndex === 3" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLorange[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2' && this.LayerColorIndex === 3">
                <img :src="this.endURLorange[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2alt' && this.LayerColorIndex === 3" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLorange[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3' && this.LayerColorIndex === 3"   style="z-index: 5;">
                <img :src="this.endURLorange[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3alt' && this.LayerColorIndex === 3" style="transform: translateX(-50%) scaleX(-1); z-index: 5;">

                <img :src="this.endURLpurple[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1' && this.LayerColorIndex === 4">
                <img :src="this.endURLpurple[0]" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'end1alt' && this.LayerColorIndex === 4" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLpurple[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2' && this.LayerColorIndex === 4">
                <img :src="this.endURLpurple[1]" alt="" class="cashCatch_overlay_image chooseEnd2" v-if="this.chosenEnd === 'end2alt' && this.LayerColorIndex === 4" style="transform: translateX(-50%) scaleX(-1);">
                <img :src="this.endURLpurple[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3' && this.LayerColorIndex === 4"   style="z-index: 5;">
                <img :src="this.endURLpurple[2]" alt="" class="cashCatch_overlay_image_bottom" v-if="this.chosenEnd === 'end3alt' && this.LayerColorIndex === 4" style="transform: translateX(-50%) scaleX(-1); z-index: 5;">


                <img :src="this.endWin" alt="" class="cashCatch_overlay_image" v-if="this.chosenEnd === 'endWin'">
                <div class="layer"></div>
                <div class="layer2"></div>

                <!-- Panel 3: playing Game Camera -->
                <section class="cashCatch cashCatch_camera" v-if="camera === true || currentState === 3">                  
                    <video id="background-video" autoplay muted loop></video>
                </section>

                <!-- Panel 4,5: playing Game Parallax -->
                <section class="cashCatch cashCatch_parallax" v-if="parallax === true || currentState === 4 || currentState === 5">                  
                    <!-- Guardians Background -->
                    <div class="horizontal-scroll-wrapper" v-if="currentState === 4" style="overflow: hidden">
                        <div class="img-wrapper skyGuardians" id="parallaxSky" ref="parallaxSky">
                            <a href="/getattachment/69815c6f-72ec-4d31-a394-fd6b890b18d6/CashCatch-Parallax-Sky-Guardians.png" target="_blank" rel="noopener">
                                <img src="/getattachment/69815c6f-72ec-4d31-a394-fd6b890b18d6/CashCatch-Parallax-Sky-Guardians.png" alt="">
                            </a>
                        </div>
                        <div class="img-wrapper standsGuardians" id="parallaxStands" ref="parallaxStands">
                            <a href="/getattachment/bb61adc5-75e6-4ac1-a9c0-84f2f2cc4785/CashCatch-Parallax-Stands-Guardians.png" target="_blank" rel="noopener">
                                <img src="/getattachment/bb61adc5-75e6-4ac1-a9c0-84f2f2cc4785/CashCatch-Parallax-Stands-Guardians.png" alt="">
                            </a>
                        </div>
                        <div class="img-wrapper fieldGuardians" id="parallaxField" ref="parallaxField">
                            <a href="/getattachment/9a3945f6-25ad-442a-8b6f-1cc0ace191dd/CashCatch-Parallax-Field-Guardians.png" target="_blank" rel="noopener">
                                <img src="/getattachment/9a3945f6-25ad-442a-8b6f-1cc0ace191dd/CashCatch-Parallax-Field-Guardians.png" alt="">
                            </a>
                        </div>
                        <div class="img-wrapper crowdGuardians" id="parallaxCrowd" ref="parallaxCrowd">
                            <a href="/getattachment/03e7d7b3-a6de-47d9-aee9-999201dc7693/CashCatch-Parallax-Foreground.png" target="_blank" rel="noopener">
                                <img src="/getattachment/03e7d7b3-a6de-47d9-aee9-999201dc7693/CashCatch-Parallax-Foreground.png" alt="">
                            </a>
                        </div>
                    </div>

                    <!-- Reds Background -->
                    <div class="horizontal-scroll-wrapper" v-if="currentState === 5" style="overflow: hidden">
                        <div class="img-wrapper skyReds" id="parallaxSky" ref="parallaxSky">
                            <a href="/getattachment/b0b5f01b-7c74-4506-a11c-f1574eabb64a/CashCatch-Parallax-Sky-Reds.png" target="_blank" rel="noopener">
                                <img src="/getattachment/b0b5f01b-7c74-4506-a11c-f1574eabb64a/CashCatch-Parallax-Sky-Reds.png" alt="">
                            </a>
                        </div>
                        <div class="img-wrapper standsReds" id="parallaxStands" ref="parallaxStands">
                            <a href="/getattachment/12055fec-0d05-44fa-8b0f-511a8ea214f7/CashCatch-Parallax-Stands-Reds.png" target="_blank" rel="noopener">
                                <img src="/getattachment/12055fec-0d05-44fa-8b0f-511a8ea214f7/CashCatch-Parallax-Stands-Reds.png" alt="">
                            </a>
                        </div>
                        <div class="img-wrapper fieldReds" id="parallaxField" ref="parallaxField">
                            <a href="/getattachment/6927e7d1-b108-4b77-b992-7626363d3592/CashCatch-Parallax-Field-Reds.png" target="_blank" rel="noopener">
                                <img src="/getattachment/6927e7d1-b108-4b77-b992-7626363d3592/CashCatch-Parallax-Field-Reds.png" alt="">
                            </a>
                        </div>
                        <div class="img-wrapper crowdReds" id="parallaxCrowd" ref="parallaxCrowd">
                            <a href="/getattachment/03e7d7b3-a6de-47d9-aee9-999201dc7693/CashCatch-Parallax-Foreground.png" target="_blank" rel="noopener">
                                <img src="/getattachment/03e7d7b3-a6de-47d9-aee9-999201dc7693/CashCatch-Parallax-Foreground.png" alt="">
                            </a>
                        </div>
                    </div>
                </section>
            </div>
        </transition>

        <div v-if="gameplay === false && [6, 7, 8, 9].includes(currentState)"> 
            <div class="circle-ring ring-leave"></div>
        </div>

        <!-- Panel 6,7,8,9: Ending Page (win/loose)-->
        <transition name="slideStagger" @before-enter="beforeEnterStagger" @enter="enterStaggerDelay">
            <div v-if="[6, 7, 8, 9].includes(currentState)" class="GameOver8bit DivWrapper8Bit">
                <div ref="staggerParent" class="endAnimation">
                    <img ref="gameOverImageBackground" class="Glove8bit" :src="GameOverWinner ? '/getattachment/771a6940-c7ca-451b-93de-dd8240c011ac/CashCatch-EndMitt-WinnerEnding.gif' : '/getattachment/ded44b18-6c00-4bab-9c50-7e3ad7079c04/CashCatch-EndMitt-NonWinnerEnding.gif'"/>

                    <p ref="subText" class="Head8bit" v-if="!enteredPromotion">{{ GameOverWinner ? `You just won $50 in Digital Lottery Cash!` : 'But you can still be a winner.' }}</p>
                    <p class="Head8bit" v-if="enteredPromotion" style="transition: none;">Check your inbox.</p>
                    
                    <p ref="bodyText" class="Body8bit" v-if="!logged && !enteredPromotion">Sign in to MyLotto Rewards<sup>&reg;</sup> or create a free account {{ GameOverWinner ? 'to claim your prize.' : 'to enter the Cash Catch Challenge Grand Prize Drawing.' }}</p>
                    <p ref="bodyText" class="Body8bit" v-if="logged && GameOverWinner">Your Winnings have been applied to your MyLotto Rewards account. Thanks for playing!</p>
                    <button v-if="!logged && !enteredPromotion" @click="EmailPopup(true)" class="Button8bit submitEmail">{{ GameOverWinner ? `CLAIM MY PRIZE` : 'ENTER TO WIN' }}</button>

                    <div v-if="!logged && showEmailPopup" class="notLogged">
                        <button class="close-btn" @click="EmailPopup(false)">✖</button>
                        <div class="EmailHead8bit">{{ GameOverWinner ? `Claim my prize` : 'Enter to win' }}</div>
                        <div class="EmailBody8bit">{{ GameOverWinner ? 'Enter your email address and we will send you instructions on how to redeem your prize.' : 'Enter your email address and we will send you instructions on how to enter the Cash Catch Challenge Grand Prize Drawing.' }}</div>
                        <input class="emailPrompt" type="email" id="emailSubmit" v-model="userEmail" placeholder="Email address">
                        <div v-if="GameOverWinner" class="EmailBody8bit" style="text-align: left;">If you're a MyLotto Rewards member, you must use the email address associated with that account</div>
                        <input class="emailPrompt" type="email" id="emailSubmit2" v-model="userEmail2" placeholder="Confirm Email address">
                        <p class="pMargin8Bit verifyError8Bit" v-if="showEmailErrorMatch">Please enter a valid and matching email address in both boxes.</p>
                        <button @click="SendEmail()" class="Button8bit submitEmail">Submit</button>
                    </div>

                    <p v-if="!logged && enteredPromotion" class="Body8bit" >{{ GameOverWinner ? `Check your email for instructions on how to claim your $50 in Digital Lottery Cash.` : 'Check your email for instructions on how to enter the Cash Catch Challenge Grand Prize Drawing.' }}</p>                    
                    <p v-if="logged && !GameOverWinner" class="Body8bit">Check your email for instructions on how to enter the Cash Catch Challenge Grand Prize Drawing.</p>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import MobileMenu from './CashCatchChallenge-Menu.vue'

    export default {
        components: { 
            MobileMenu,
        },
        data: function () {
            return {
                events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
                
                //user information
                token: '',
                logged: false,
                user: '',
                userAuthed: '',
                userEmail: '',
                userEmail2: '',
                instanceID: '',
                itemID: '',
                userId: null,
                GameOverWinner: false,
                enteredPromotion: false,

                //team/location
                area: '',
                city: '',
                team: '',
                apiTeam: 0,
                cle: false,
                reds: false,

                
                //testing
                testing: false,
                testingToggle: false,

                //gameplay
                currentState: null,
                gameplay: false,
                camera: false,
                parallax: false,
                            //red,          Green,      blue,       orange,     purple
                layerColors: ['#A10409',    '#023D1C',  '#072A58',  '#DE620A',  '#481460'],
                LayerColorIndex: null,

                flybyURL: ["/getattachment/49cd9cd2-5a47-4f93-9dec-214733920295/CashCatch_Flyby1.gif",
                            "/getattachment/ce2d65db-1f44-471f-a0cc-3b0c1098f13e/CashCatch_Flyby2.gi",
                            "/getattachment/6ee6da94-beb0-4a36-92f1-d4c578ebaf5e/CashCatch_Flyby3.gif",
                ],
                flybyGifLength:[5200, 5200, 5760, 5760, 5760, 5760],
                flybys: ["flyby1", "flyby1alt", "flyby2", "flyby2alt", "flyby3","flyby3alt"],
                chosenFlyby: '',

                endURLred: ["/getattachment/db0abbdd-aa10-496f-8796-e88fa95d9065/CashCatch_NonWin1-Red.gif",
                            "/getattachment/77db9472-82dd-4a88-991a-57c638d5841c/CashCatch_NonWin2-Red.gif",
                            "/getattachment/f818c90c-f9ac-4ec8-bf8f-9cfbe8b5cefe/CashCatch_NonWin3-red.gif",
                ],
                endURLgreen: ["/getattachment/15a561b2-491a-4313-a196-ee03ecfd1dd1/CashCatch_NonWin1-Green.gif",
                              "/getattachment/b2650cc9-dfbd-44ca-b30e-9d21094fa8c1/CashCatch_NonWin2-Green.gif",
                              "/getattachment/1e682d4d-e832-4380-b972-31c3658938f6/CashCatch_NonWin3-Green.gif",
                ],
                endURLblue: ["/getattachment/0194f12a-7d28-446d-bd90-b898029771db/CashCatch_NonWin1-Blue.gif",
                             "/getattachment/bcdb4e80-5546-490e-a6cb-c240d06cfef0/CashCatch_NonWin2-Blue.gif",
                             "/getattachment/36899634-5e0f-4dbc-a630-d18c39f0c21b/CashCatch_NonWin3-Blue.gif",
                ],
                endURLorange: ["/getattachment/645e1fbf-8aa1-47f7-a55a-e93fa36f4f54/CashCatch_NonWin1-Orange.gif",
                               "/getattachment/5222df50-17bd-4e45-8555-f1012107fdf7/CashCatch_NonWin2-Orange.gif",
                               "/getattachment/b58a09d7-4113-4d89-84e4-f30725256af6/CashCatch_NonWin3-Orange.gif",
                ],
                endURLpurple: ["/getattachment/75c95563-3bd4-453b-a802-19744b1d8c02/CashCatch_NonWin1-Purple.gif",
                               "/getattachment/e09618e5-4b13-4fa5-8489-64be501cb1d0/CashCatch_NonWin2-Purple.gif",
                               "/getattachment/37f6b7b5-fb34-404c-b806-ec592e85302c/CashCatch_NonWin3-Purple.gif",
                ],
                NonWinGifLength:[1720, 1720, 3440, 3440, 3440, 3440],
                ends: ["end1", "end1alt", "end2", "end2alt", "end3", "end3alt"],
                chosenEnd: '',
                
                endWin: "/getattachment/d02a7e0d-aea5-45a2-9820-7eb7953f8268/CashCatch_Win.gif",

                // Parallax
                previousX: 0,
                previousY: 0,
                parallaxSkyLeft: -220,
                parallaxStandsLeft: -220,
                parallaxFieldLeft: -220,
                parallaxCrowdLeft: -220,

                //glove
                targetX: 0,
                targetY: 0,
                smoothedX: 0,
                smoothedY: 0,

                //Validations
                error: false,
                isChecked: false,
                showError: false,
                // showEmailErrorBlank: false,
                showEmailErrorMatch: false,
                showEmailPopup: false,

                //animation
                showText: false,
                showImage: false,
            }
        },
        mounted: function () {
            this.getToken();
            this.getTestingStatus();
        },
        methods: {
            getToken() {
                this.getAPItoken()
                .then((token) => {
                    this.token = token;
                    this.user = this.$cookies.get('apiToken');
                    this.userAuthed = this.isUserAuthed();

                    if(this.userAuthed){
                        this.logged = true;
                        this.userEmail = this.user.user.username;
                        this.userId = this.user.user.userId;
                    }
                    this.getTeam();
                    this.getState();
                });
            },
            async getTestingStatus(){
                try {
                    let status = await this.getContentByKey('fe-feature-switch','OLCCashCatchTestingStatus');
                    this.testing = status.CashCatchTesting;
                    return;

                } catch (error) {
                    console.error(error);
                }
            },
            ToggleTest(){
                if (this.testingToggle){
                    this.testingToggle = false;
                }else{
                    this.testingToggle = true;
                }
            },
            getState(panel) {
                if (panel === null || panel === undefined) {
                    this.gameEnabled();
                } else {
                    if (panel === 0){this.currentState = 0;} //game is not active and way to far in advance/after
                    if (panel === 1){this.currentState = 1;} //game is not active BUT baseball game is going on (pre-game state)
                    if (panel === 2){this.currentState = 2;} //game is active Landing page
                    if (panel === 3){this.currentState = 3; this.gameplay = true; this.camera = true; this.parallax = false; this.activateCamera();} //gameplay Camera
                    if (panel === 4){this.currentState = 4; this.gameplay = true; this.camera = false; this.parallax = true; this.activateParallax();} //gameplay Parallax Guardians
                    if (panel === 5){this.currentState = 5; this.gameplay = true; this.camera = false; this.parallax = true; this.activateParallax();} //gameplay Parallax Reds 
                    if (panel === 6){this.currentState = 6; this.GameOverWinner = false; this.logged = false; this.enteredPromotion = false;} //Loose page not Logged In
                    if (panel === 7){this.currentState = 7; this.GameOverWinner = false; this.logged = true; this.enteredPromotion = false;} //Loose page is Logged In  
                    if (panel === 8){this.currentState = 8; this.GameOverWinner = true; this.logged = false; this.enteredPromotion = false;} //Win page not Logged In
                    if (panel === 9){this.currentState = 9; this.GameOverWinner = true; this.logged = true; this.enteredPromotion = false;} //Win page is Logged In
                    if (panel === 10){this.currentState = 10;} //user has already payed the game
                }
            },
            getTeam() {
                let pathName = window.location.pathname;

                if (pathName.indexOf('reds') >= 0) {
                    this.cle = false;
                    this.reds = true;
                    this.area = 'EnterEightBitAtBatCincinnati';
                    this.team = 'Reds';
                    this.city = 'Cincinnati';
                    this.apiTeam = 1;
                } else {
                    this.cle = true;
                    this.reds = false;
                    this.area = 'EnterEightBitAtBatCleveland';
                    this.team = 'Guardians';
                    this.city = 'Cleveland';
                    this.apiTeam = 0; 
                }
            },
            gameEnabled() {
                let url = process.env.VUE_APP_APIURL + '/1.0/Games/CashCatch/LoadGame?team=' + this.apiTeam;
                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + this.token
                    }
                })
                .then((response) => response.json())
                .then((json) => {
                    // this.currentState = json.data;
                    // console.log(json);
                    let StateGet = json.data,
                        alreadyplayed = getCookie("OLCLotteryGameCookie"),
                        cookieDate = new Date(alreadyplayed),
                        today = new Date();
                    cookieDate.setHours(0, 0, 0, 0);
                    today.setHours(0, 0, 0, 0);

                    if(StateGet === 7){ //Game Active
                        if(alreadyplayed != "" && cookieDate.getTime() === today.getTime()){ //they have already played today
                            this.currentState = 10;
                        }else{ //they still can play
                            this.currentState = 2;
                        }
                    } else if (StateGet === 3){ //pregame
                        this.currentState = 1;
                    } else{  //no Game today (StateGet=11 or -1(error))
                        this.currentState = 0;
                    }
                })
            },

            async requestMotionPermission () {
                if (!this.isChecked) {
                    this.showError = true;
                    return;
                }
                if (typeof DeviceMotionEvent?.requestPermission === 'function') {
                    try {
                        const motionPermission = await DeviceMotionEvent.requestPermission();
                        const orientationPermission = await DeviceOrientationEvent.requestPermission();

                        if (motionPermission === 'granted' && orientationPermission === 'granted') {
                            window.addEventListener('deviceorientation', this.handleOrientation);
                            window.addEventListener('devicemotion', this.handleMotion);
                        } else {
                            window.addEventListener('touchmove', this.handleTouchMove, { passive: true });
                            window.addEventListener('touchend', this.resetPosition);
                            window.addEventListener('touchcancel', this.resetPosition);
                        }
                        this.CameraPermission();
                        this.updateSmoothedPosition();
                    } catch (error) {
                        console.error("Motion access denied:", error);
                        window.addEventListener('touchmove', this.handleTouchMove, { passive: true });
                        this.CameraPermission();
                        this.updateSmoothedPosition();
                        window.addEventListener('touchend', this.resetPosition);
                        window.addEventListener('touchcancel', this.resetPosition);
                    }
                } else {
                    window.addEventListener('touchmove', this.handleTouchMove, { passive: true });
                    this.CameraPermission();
                    this.updateSmoothedPosition();
                    window.addEventListener('touchend', this.resetPosition);
                    window.addEventListener('touchcancel', this.resetPosition);
                }
            },

            async CameraPermission(){
                if (!this.isChecked) {
                    this.showError = true;
                    return;
                }
                this.showError = false;
                try {
                    await navigator.mediaDevices.getUserMedia({ video: true });

                    // If access is granted, proceed
                    this.activateCamera();
                    this.currentState = 3;
                } catch (error) {
                    // If access is denied, fallback to parallax
                    console.error("Camera access denied:", error);
                    this.activateParallax();
                    if (this.cle === true){
                        this.currentState = 4; //guardians
                    }else{
                        this.currentState = 5; //reds
                    }
                }
                this.amIaWinner(this.userId, this.apiTeam);
            },
            handleTouchMove(event) {
                const touch = event.touches[0];
                const screenWidth = window.innerWidth;
                const screenHeight = window.innerHeight;

                this.targetX = ((touch.clientX / screenWidth) - 0.5) * 180;
                this.targetY = ((touch.clientY / screenHeight) - 0.5) * 180;
            },
            handleOrientation(event) {
                const baseBeta = 90;
                const baseGamma = 0;
                this.targetX = (event.gamma - baseGamma) * 2;
                this.targetY = (event.beta - baseBeta) * 2;
            },
            updateSmoothedPosition() {
                if ([6, 7, 8, 9].includes(this.currentState)) {
                    this.smoothedX = 0;
                    this.smoothedY = 0;
                    return;
                }
                this.smoothedX += (this.targetX - this.smoothedX) * 0.1;
                this.smoothedY += (this.targetY - this.smoothedY) * 0.1;

                this.smoothedX = Math.max(-40, Math.min(40, this.smoothedX));
                this.smoothedY = Math.max(-40, Math.min(40, this.smoothedY));

                const glove = document.querySelector('.Glove8bitGame');
                const end = document.querySelector('.chooseEnd2');
                    if (glove) {
                        glove.style.transform = `translate(-50%, 0) translate(${this.smoothedX}px, ${this.smoothedY}px)`;
                    }
                    if (end) {
                        end.style.transform = `translate(-50%, 0) translate(${this.smoothedX}px, ${this.smoothedY}px)`;
                    }
                requestAnimationFrame(this.updateSmoothedPosition);
            },
            resetPosition() {
                this.targetX = 0;
                this.targetY = 0;
            },
            amIaWinner (userId, team) {
                if(userId != null && userId != undefined){
                    this.createCookie();
                }

                let url = process.env.VUE_APP_APIURL + '/1.0/Games/CashCatch/EnterCashCatch?team=' + team;

                fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': "Bearer " + this.token
                    }
                })
                .then((response) => response.json())
                .then((json) => {
                    // console.log(json);
                    // console.log(this.token);
                    this.instanceID = json.data.instanceID;
                    this.itemID = json.data.instantPrizeID; 
                    this.GameOverWinner = json.data.isWinner; 
                    if (!json.data){
                        this.instanceID = 0;
                        this.itemID = -1;
                        this.GameOverWinner = false; 
                    }
                })
            },
            createCookie() {
                let timeNow = new Date(),

                    time2hour = timeNow.getTime() + 2 * 60 * 60 * 1000,
                    expires = 'expires='+new Date(time2hour).toUTCString(),

                    cookieValue  = timeNow,
                    cookieName = 'OLCLotteryGameCookie',
                    cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
                    document.cookie = cookie;

            },
            chance() {
                let random = Math.floor(Math.random() * (100 - 1 + 1) + 1);
                return random;
            },
            activateParallax() {
                this.parallax = true;
                this.camera = false;
                this.gameplay = true;
                
                this.trackEvents();

                setTimeout(() => { //start animations after 1.5 seconds (transition time)
                    this.startGame();
                }, 1500);

                let chanceNumberLayerColor = this.chance(); //set the layer color
                this.LayerColorIndex = this.selectLayerColor(chanceNumberLayerColor);
                let LayerColorChoice = this.layerColors[this.LayerColorIndex];

                setTimeout(() => {
                    document.querySelector('.layer').style.backgroundColor = LayerColorChoice;
                    document.querySelector('.layer2').style.backgroundColor = LayerColorChoice;
                }, 100);               
                
            },
            trackEvents(event) {
                if (this.parallax === true) {
                    this.events.forEach( function (event){
                        window.addEventListener(event, this.parallaxGame);
                    }, this)

                    setTimeout(() => {
                        const moveArea = document.getElementById('gameArea');
                        moveArea.addEventListener('mousemove', this.parallaxGame.bind(this));
                        moveArea.addEventListener('touchmove', this.parallaxGame.bind(this), { passive: false });
                    }, 1000);

                }
            },
            parallaxGame(event) {
                if (event.type === 'touchmove') {
                    event.preventDefault();
                }

                const parallaxSkyElement = document.getElementById('parallaxSky'),
                    parallaxStandsElement = document.getElementById('parallaxStands'),
                    parallaxFieldElement = document.getElementById('parallaxField'),
                    parallaxCrowdElement = document.getElementById('parallaxCrowd');


                let parallaxSkyLeft = this.parallaxSkyLeft,
                    parallaxStandsLeft = this.parallaxStandsLeft,
                    parallaxFieldLeft = this.parallaxFieldLeft,
                    parallaxCrowdLeft = this.parallaxCrowdLeft;

                let clientX, clientY ;

                if (event.type.startsWith('touch')) {
                    clientX = event.touches[0].clientX;
                    clientY = event.touches[0].clientY;
                } else {
                    clientX = event.clientX;
                    clientY = event.clientY;
                }

                if (clientX > this.previousX) {
                    this.parallaxSkyLeft < -200 ? parallaxSkyLeft = parallaxSkyLeft + 1 : parallaxSkyLeft = this.parallaxSkyLeft;
                    this.parallaxStandsLeft < -180 ? parallaxStandsLeft = parallaxStandsLeft + 2 : parallaxStandsLeft = this.parallaxStandsLeft;
                    this.parallaxFieldLeft < -120 ? parallaxFieldLeft = parallaxFieldLeft + 4 : parallaxFieldLeft = this.parallaxFieldLeft;
                    this.parallaxCrowdLeft < -80 ? parallaxCrowdLeft = parallaxCrowdLeft + 6 : parallaxCrowdLeft = this.parallaxCrowdLeft;
                } else {
                    this.parallaxSkyLeft > -240 ? parallaxSkyLeft = parallaxSkyLeft - 1 : parallaxSkyLeft = this.parallaxSkyLeft;
                    this.parallaxStandsLeft > -260 ? parallaxStandsLeft = parallaxStandsLeft - 2 : parallaxStandsLeft = this.parallaxStandsLeft;
                    this.parallaxFieldLeft > -300 ? parallaxFieldLeft = parallaxFieldLeft - 4 : parallaxFieldLeft = this.parallaxFieldLeft;
                    this.parallaxCrowdLeft > -340 ? parallaxCrowdLeft = parallaxCrowdLeft - 6 : parallaxCrowdLeft = this.parallaxCrowdLeft;
                }

                parallaxSkyElement.style.left = `${parallaxSkyLeft}px`;
                parallaxStandsElement.style.left = `${parallaxStandsLeft}px`;
                parallaxFieldElement.style.left = `${parallaxFieldLeft}px`;
                parallaxCrowdElement.style.left = `${parallaxCrowdLeft}px`;

                this.previousX = clientX;
                this.parallaxSkyLeft = parallaxSkyLeft;
                this.parallaxStandsLeft = parallaxStandsLeft;
                this.parallaxFieldLeft = parallaxFieldLeft;
                this.parallaxCrowdLeft = parallaxCrowdLeft;
                this.previousY = clientY;
            },
            async activateCamera() {
                this.parallax = false;
                this.camera = true;
                this.gameplay = true;

                await this.$nextTick(); 
                const video = document.getElementById('background-video');
                while (!video) {
                    await new Promise(resolve => setTimeout(resolve, 100)); // Check every 100ms
                    video = document.getElementById('background-video');
                }


                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices.getUserMedia({ video: {facingMode: 'environment'} })
                    .then(stream => {
                        video.playsInline = true;
                        video.srcObject = stream;

                        setTimeout(() => { //start animations after 1.5 seconds (transition time)
                            this.startGame();
                        }, 1500);

                        let chanceNumberLayerColor = this.chance(); //set the layer color
                        this.LayerColorIndex = this.selectLayerColor(chanceNumberLayerColor);
                        let LayerColorChoice = this.layerColors[this.LayerColorIndex];

                        setTimeout(() => {
                            document.querySelector('.layer').style.backgroundColor = LayerColorChoice;
                            document.querySelector('.layer2').style.backgroundColor = LayerColorChoice;
                        }, 100);    

                    })
                    .catch(error => {
                        console.error('Error accessing camera:', error);
                    });
                } else {
                    console.error('getUserMedia is not supported on this browser');
                }
            },
            selectLayerColor(chanceNumber, index = 0, step = 100 / this.layerColors.length) {
                if (chanceNumber <= step * (index + 1)) {
                    return index;
                }
                return this.selectLayerColor(chanceNumber, index + 1, step);
            },
            selectFlyby(chanceNumber, index = 0, step = 100 / this.flybys.length) {
                if (chanceNumber <= step * (index + 1)) {
                    return index;
                }
                return this.selectFlyby(chanceNumber, index + 1, step);
            },
            selectNonWin(chanceNumber, index = 0, step = 100 / this.ends.length) {
                if (chanceNumber <= step * (index + 1)) {
                    return index;
                }
                return this.selectNonWin(chanceNumber, index + 1, step);
            },
            startGame() {
                let totalTime,
                    flybyTime,
                    chancenumberFlyby = this.chance(),
                    chancenumberWin = this.chance(),

                    FlybyIndex = this.selectFlyby(chancenumberFlyby),
                    FlybyChoice = this.flybys[FlybyIndex],
                    FlybyGifLength = this.flybyGifLength[FlybyIndex],

                    NonWinIndex = this.selectNonWin(chancenumberWin),
                    NonWinChoice = this.ends[NonWinIndex],
                    NonWinGifLength = this.NonWinGifLength[NonWinIndex];

                // console.log(FlybyChoice);
                // console.log(NonWinChoice);

                setTimeout(() => {
                    this.chosenFlyby = FlybyChoice;
                }, 1000); 

                flybyTime = 1000+ FlybyGifLength +1500;

                if (this.GameOverWinner === true) {
                    setTimeout(() => {
                        this.chosenFlyby = '';
                        this.chosenEnd = 'endWin';
                    }, flybyTime);
                } else {
                    setTimeout(() => {
                        this.chosenFlyby = '';
                        this.chosenEnd = NonWinChoice;
                    }, flybyTime);
                }

                if (this.GameOverWinner === true){
                    totalTime = flybyTime + 7360;                    
                } else{
                    totalTime = flybyTime + NonWinGifLength;                    
                }

                setTimeout(() => {
                    this.chosenEnd = '';
                    this.parallax = false;
                    this.camera = false;
                    this.gameplay = false;
                    this.currentState = 6;
                }, totalTime);
            },  
            EmailPopup(val){
                this.showEmailPopup = val;
            },
            SendEmail(){
                var emailRegExa = /^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                var emailTesta = emailRegExa.test(this.userEmail);

                if(this.userEmail === null || this.userEmail === undefined || this.userEmail === '' || this.userEmail2 === null || this.userEmail2 === undefined || this.userEmail2 === '' || this.userEmail != this.userEmail2 || this.userEmail.length < 5 || emailTesta === false ){
                    this.showEmailErrorMatch = true;
                    return
                }

                else {
                    this.showEmailPopup = false;
                    this.showEmailErrorMatch = false;
                    this.enteredPromotion = true;

                    let url = process.env.VUE_APP_APIURL + '/1.0/Games/CashCatch/EnterCashCatchCallback?itemID=' + this.itemID + '&email=' + this.userEmail + '&instanceID=' + this.instanceID + '&team=' + this.apiTeam;

                    fetch(url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + this.token
                        }
                    })
                    .then((response) => response.json())
                    .then((json) => {
                        // console.log(json);
                    })

                    this.createCookie();            
                }
            },
            beforeEnterStagger(el) {
                const children = this.$refs.staggerParent?.children || [];
                Array.from(children).forEach((child, i) => {
                    child.style.opacity = 0;
                    child.style.transform = 'translateY(30px)';
                    child.style.transition = `all 0.5s ease ${i * 200}ms`;
                });
            },
            enterStagger(el, done) {
                const children = this.$refs.staggerParent?.children || [];
                Array.from(children).forEach((child) => {
                    requestAnimationFrame(() => {
                        child.style.opacity = 1;
                        child.style.transform = 'translateY(0)';
                    });
                });
                const totalDuration = children.length * 200 + 400;
                setTimeout(done, totalDuration);
            },
            enterStaggerDelay(el, done) {
                const children = this.$refs.staggerParent?.children || [];

                setTimeout(() => {
                    Array.from(children).forEach((child) => {
                        requestAnimationFrame(() => {
                            child.style.opacity = 1;
                            child.style.transform = 'translateY(0)';
                        });
                    });
                    const totalDuration = children.length * 200 + 400;
                    setTimeout(done, totalDuration + 2800);
                }, 2800);
            },
            leaveStagger(el, done) {
                const children = this.$refs.staggerParent?.children || [];
                Array.from(children).forEach((child, i) => {
                    child.style.transition = `all 0.75s ease ${i * 200}ms`;
                    child.style.opacity = 0;
                    child.style.transform = 'translateY(-30px)';
                });
                const totalDuration = children.length * 200 + 300;
                setTimeout(done, totalDuration);
            },
		}
    };
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Bevan&family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

// Test panel Styles
#test-panel {
    position: absolute;
    z-index: 25;
    display: flex;
    flex-wrap: wrap;
    top: 90px;
    left:0;
    button{
        margin:2px;
        color:black;
        font-weight: 700;
        font-size: 0.95rem;
        letter-spacing: .05em;
        padding: 0px 7px;
        height:20px;
    }
}

/* Transition styles*/
/* Game Circle */
.circle-enter-active, .circle-leave-active {
  animation-duration: 3s;
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.circle-enter-active {
  animation-name: circleExpand;
}

.circle-leave-active {
  animation-name: circleContract;
}

@keyframes circleExpand {
  0% {
    clip-path: circle(0vh at 50% 50%);
  }
  100% {
    clip-path: circle(150vh at 50% 50%);
  }
}

@keyframes circleContract {
  0% {
    clip-path: circle(150vh at 50% 50%);
  }
  100% {
    clip-path: circle(0vh at 50% 50%);
  }
}
.circle-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 100vw;
  transform: translate(-50%, -50%);
  border: 6px solid white;
  border-radius: 100%;
  z-index: 5;
}

.circle-ring.ring-enter {
  animation: ringExpand 2s ease-in-out both;
}

.circle-ring.ring-leave {
  animation: ringContract 2.16s ease-in-out both;
  animation-delay: .9s;
}

@keyframes ringExpand {
  0% {
    width: 0vh;
    height: 0vh;
    border-width: 20px;
    opacity: 1;
  }
  50% {
    border-width: 35px;
    opacity: 1;
  }
  100% {
    width: 150vh;
    height: 150vh;
    border-width: 55px;
    opacity: 0;
  }
}

@keyframes ringContract {
  0% {
    width: 150vh;
    height: 150vh;
    border-width: 55px;
    opacity: 1;
  }
  50% {
    border-width: 35px;
    opacity: 1;
  }
  100% {
    width: 0vh;
    height: 0vh;
    border-width: 20px;
    opacity: 0;
  }
}



/* Stagger Landing */
.slideStagger-enter-from {
  opacity: 0;
  transform: translateY(30px);
}
.slideStagger-enter-active {
  transition: all 0.5s ease;
  opacity: 1;
  transform: translateY(0);
}

/* Leave */
.slideStagger-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.slideStagger-leave-active {
  transition: all 0.75s ease;
  opacity: 0;
  transform: translateY(-30px);
}

.LandingPosition > * {
  will-change: opacity, transform;
}
.endAnimation > * {
  will-change: opacity, transform;
}
.notyetAnimation > * {
    will-change: opacity, transform;
}
//end Stagger Landing

/* generic styles */
.background8Bit{
  background: linear-gradient(to bottom, 
    rgb(19, 63, 40) 10%, 
    rgb(29, 94, 60) 30%, 
    rgb(35, 114, 72) 50%, 
    rgb(29, 94, 60) 70%, 
    rgb(19, 63, 40) 90%);
  height: 100dvh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;
}

.DivWrapper8Bit{
    display: flex;
    flex-grow: 1;
    padding: 0px 20px 110px 20px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.Head8bit{
  font-family: 'Kanit';
  color: rgb(254,210,6);
  font-weight: 600;
  font-size: 3rem;
  margin: 0px auto;
  line-height: 1.1em;
  position: relative;
  text-align: center;
}

.SubHead8bit{
  font-family: 'Kanit';
  color: white;
  font-weight: 600;
  font-size: 2.4rem;
  line-height: 1.2em;
  position: relative;
  margin: 20px auto;
  text-align: center;
}

.Body8bit{
  font-family: 'Kanit';
  color: white;
  font-size: 1.6rem;
  line-height: 1.3em;
  max-width:335px;
  margin: 0.5em auto;
  position: relative;
}

.Disclaimer8bit{
  font-family: 'Kanit';
  color: white;
  font-size: 1.6rem;
  line-height: 1.2em;
  max-width:335px;
  margin: 0.5em auto;
  position: relative;
}

.Button8bit{
  position: relative;
  padding: 15px 20px;
  font-size: 2rem;
  font-weight: 800;
  cursor: pointer;
  background-color: black;
  color: white;
  border-radius: 13px;
  letter-spacing: 0.45px;
  margin: 0.5em auto;
}

.LandingHead8bit{
    width: 80vw;
    max-width: 300px;
    margin: 0px auto 15px auto;
    position: relative;
    display: block;
}

/* not Time yet page styles */
.notTimeYet{
    max-width: 450px;
    .notyetAnimation{
        display:flex;
        flex-direction: column;
        align-items: center;
        z-index: 5;
    }
    .Head8bit{
        font-size: 3rem;
        line-height: 1em;
    }
    .SubHead8bit{
        max-width: 310px;
        font-size: 2rem;
        line-height: 1.05em;
    }
}

/* Landing page styles */
.Landing8bit {
    .LandingPosition{
        z-index: 5;
    }
    .yellow{
        color: #FED207;
        font-weight: 600;
        margin-bottom: 5px;
        margin-top: 10px !important;
    }
    .Body8bit{
        margin-top: 0px;
    }
    .pMargin8Bit{
        margin:0px auto 3px auto;
        input{
        margin:0px;
        }
    }
    .checkbox8bit{
        width:110%;
        max-width: 335px;
        margin: 0px auto;
        .checkboxtext{
            font-size: 1.5rem;
            margin: .5rem 0 .5rem 0.75rem;
        }
    }

  .Popup{
    position: fixed;
    top: 50%;
    left: 50%;
    width: 90%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 60px 20px;
    text-align: center;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;

    .PopupHead8bit{
        font-family: 'Kanit';
        font-size: 1.8rem;
        font-weight: 400;
        line-height: 1.1em;
        margin-bottom: 10px;
    }
    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
        color: black;
    }
  }
}
.LandingFooter8bitWrapper{
    display: inline-grid;
    position: absolute;
    bottom: 0;
    justify-items: center;
    
    .LandingFooter8bit{
        width: 100vw;
        position: relative;
        z-index: 0;
    }
    .Darken{
        z-index: 1;
        mix-blend-mode: darken;
        max-width: 600px;
    }
    .Multiply{
        z-index: 2;
        mix-blend-mode: multiply;
        max-width: 600px;
    }

    .lightenBackground{
        min-height: 100dvh;
        background: linear-gradient(to bottom, 
                                rgb(19, 63, 40) 10%, 
                                rgb(29, 94, 60) 30%, 
                                rgb(35, 114, 72) 50%, 
                                rgb(35, 114, 72) 70%, 
                                rgb(35, 114, 72) 90%);
        z-index: 0;
        position: absolute;
        bottom: 0;
    }
}
.LandingFooter8bitWrapper> * {
  grid-column: 1;
  grid-row: 1;
}

/* GameOver/Winner Page Styles */
.GameOver8bit{
    .endAnimation {
        display:flex;
        flex-direction: column;
        align-items: center;
    }
    .Head8bit{
        max-width: 525px;
        color: gold;
    }
  .Body8bit{
    color: white;
    text-align: center;
  }
  .Glove8bit{
    width: 120%;
    max-width: initial;
    z-index: 0;
    margin: -60% 0px -95% 0%;
  }

  .notLogged{
    position: fixed;
    top: 50%;
    left: 50%;
    width: 90%;
    transform: translate(-50%, -50%);
    background: white;
    padding: 60px 20px;
    text-align: center;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    align-items: center;

    .pMargin8Bit{
        margin-bottom:3px;
    }
    .verifyError8Bit{
        color: rgb(245, 43, 43);
        font-size: 1.5rem;
        line-height: 1.3em;
        font-weight: 400;
    }

    .EmailHead8bit{
        font-family: 'Kanit';
        font-size: 4rem;
        font-weight: bold;

    }
    .EmailBody8bit{
        font-family: 'Kanit';
        font-size: 2rem;
        font-weight: 400;
        margin-bottom: 20px;
    }

    .emailPrompt{
        border: 1px solid #7A7A7A;
        height:45px;
        border-radius: 4px;
        width: 100%;
        font-family: "Kanit";
        font-size: 2rem;
    }
    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 18px;
        cursor: pointer;
        color: black;
    }
  }
}

/* gameplay */
.cashCatch_game {
    position: absolute;
    top:0;
    width: 100%;
    min-width: 100vw;
    max-width: 600px;
    height: 100dvh;
    .gameArea{
        opacity: 0%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 600px;
        height: 100%;
        z-index: 20;
    }

    .layer {
        mix-blend-mode: color;
        opacity: 100%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 600px;
        height: 100%;
        z-index: 1;
    }
    .layer2 {
        mix-blend-mode: multiply;
        opacity: 60%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 600px;
        height: 100%;
        z-index: 2;
    }

    .Glove8bitGame {
        position: absolute;
        bottom: 100px;
        left: 50%;
        transform: translateX(-50%);
        width: 250px !important;
        z-index: 4;
        transition: transform 0.1s ease-out;
    }
    .ar-instructions{
        font-family: 'Kanit';
        border: 1px solid white;
        border-radius: 6px;
        background-color:rgba(0, 0, 0, 0.65);
        color: white;
        font-weight: 500;
        font-size:1.25rem;
        line-height: 1.3em;
        padding:10px;
        z-index: 4;
        align-self: end;
        margin: 10px auto;
        text-align: center;
        width: 80%;
        position: absolute;
        left: 10%;
        bottom: 2.5%;
    }

    .cashCatch_camera {
        overflow: hidden;
        z-index: 0;
        display: flex;
    }

    .cashCatch_overlay_image {
        position: absolute;
        z-index: 3;
        pointer-events: none;
        bottom: 15px;
        left:50%;
        width:550px;
        max-width: initial;
        transform: translateX(-50%);
    }
    .cashCatch_overlay_image_bottom {
        position: absolute;
        z-index: 3;
        pointer-events: none;
        bottom: 0;
        left:50%;
        width:550px;
        max-width: initial;
        transform: translateX(-50%);
    }

    .cashCatch_overlay_image_flyby {
        position: absolute;
        z-index: 3;
        pointer-events: none;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    .cashCatch_parallax {
        position: relative;
        height: 100dvh;
        width: 100%;
        max-width: 600px;
        margin: 0 auto;
        overflow-x: hidden;
        overflow-y: hidden;

        .horizontal-scroll-wrapper {
            .img-wrapper{
                z-index: 0;
            }

            .skyGuardians {
                width: 1200px;
                position: absolute;
                bottom: 230px;
                left: -220px;
            }

            .standsGuardians {
                position: absolute;
                width: 1200px;
                bottom: 250px;
                left: -220px;
            }

            .fieldGuardians {
                width: 1200px;
                position: absolute;
                bottom: 130px;
                left: -220px;
            }

            .crowdGuardians {
                width: 1200px;
                position: absolute;
                bottom: 0;
                left: -220px;
            }
            .skyReds {
                width: 1200px;
                position: absolute;
                top: 0;
                left: -220px;
            }

            .standsReds {
                position: absolute;
                width: 1200px;
                bottom: 175px;
                left: -220px;
            }

            .fieldReds {
                width: 1200px;
                position: absolute;
                bottom: 105px;
                left: -220px;
            }

            .crowdReds {
                width: 1200px;
                position: absolute;
                bottom: 0;
                left: -220px;
            }
        }
    }
}

.cashCatch {
    margin: 0 auto;
    width: 100%;
    max-width: 768px;
    max-height: 1024px;
    min-height: 100dvh;
}

#background-video {
    position: relative;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100dvh;
    z-index: 0;
    object-fit: cover;
    max-width: 768px;
    max-height: 1024px;
}

</style>
